import React from 'react'
import { useSelector } from 'react-redux';
import _ from 'lodash'

import CardCarousel from '../../components/CardCarousel/CardCarousel';
import { getLink, getLinkText, getTitle } from '../../redux/reducers/configuration'
import {
  getTours,
  getToursError,
  getToursLoading
} from '../../redux/reducers/tours'
import { htmlDecode } from '../../utilities/content/parseValidHtmlString'
import '../../styles/scss/views/tours-container.scss'

const ToursContainer = () => {
  const error = useSelector(getToursError)
  const link = useSelector(getLink)
  const linkText = useSelector(getLinkText)
  const loading = useSelector(getToursLoading)
  const title = useSelector(getTitle)
  const tours = useSelector(getTours)

  return !error && !loading && !_.isEmpty(tours) && (
    <div className="tours">
      <div className="tours__content-container">
        <div className="u-full-width tours__content-container__background-skew" />
        {title && (
          <h2
            className="tours__content-container__cards-header"
            dangerouslySetInnerHTML={{ __html: htmlDecode(title) }}
          />
        )}
        <div className="u-full-width tours__content-container__cards-container">
          <CardCarousel tours={tours} />
        </div>
        {Boolean(link && linkText) && (
          <div className="u-flex u-flex-justify-center tours__content-container__link-container">
            <a href={link}>{linkText}</a>
          </div>
        )}
      </div>
    </div>
  )
}

export default ToursContainer
